import React from "react";

// Material UI
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const OrderSearchHeader = () => {
  const headCells = [
    { id: "Customer Name", numeric: false, label: "Customer Name" },
    { id: "Brand", numeric: false, label: "Brand" },
    { id: "Campaign", numeric: false, label: "Campaign" },
    { id: "SCN", numeric: false, label: "SCN" },
    { id: "Total", numeric: false, label: "Total" },
    { id: "Order Status", numeric: false, label: "Order Status" },
    { id: "Customer Message", numeric: false, label: "Customer ID" },
    { id: "Order ID", numeric: true, label: "Order ID" },
    { id: "IP Address", numeric: false, label: "IP Address" },
    { id: "Bank", numeric: false, label: "Bank" },
    { id: "Card Type", numeric: false, label: "Card Type" },
    { id: "Email", numeric: false, label: "Email" },
    { id: "Date and Time", numeric: false, label: "Order Date and Time" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({id, label}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
            size="medium"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default OrderSearchHeader;
